module.exports = __webpack_public_path__ + "static/media/avatar.98acc124.png";